import { TempLineType } from "@/store/flowsheet/flowsheet.slice"
import { Edge } from "@antv/x6"
import { Input, Select } from "antd"
import classNames from "classnames"
import { useState } from "react"
import { PointsEditor } from "./PointsEditor"
import { useReloadWhenUnitChange } from "./useReloadWhenUnitChange"

interface LinePanelProps {
  unit: Edge
  hasHeader?: boolean
}
export const LinePanel = (props: LinePanelProps) => {
  const {unit, hasHeader = true} = props
  const initData = unit.getData()
  const [data, setData] = useState(initData)
  const {style = {}} = data
  useReloadWhenUnitChange(unit)
  const start = unit.getSource()
  const end = unit.getTarget()
  const vertices = unit.getVertices()

  const allPoints = [start, ...vertices, end]
  
  const updateData = (changes) => {
    const newData = {...data, ...changes}
    unit.setData(newData)
    setData(newData)
  }

  const onColorChange = (e) => {
    const color = e.target.value
    const newStyle = {...style, color}
    updateData({style: newStyle})
    unit.setAttrByPath('path/stroke', color)
    unit.setAttrByPath('path/stroke-width', newStyle.width || 2)
  }

  const onWidthChange = (width: string) => {
    const newStyle = {...style, width}
    updateData({style: newStyle})
    unit.setAttrByPath('path/stroke-width', width)
  }

  const onTypeChange = (type: TempLineType) => {
    const newStyle = {...style, lineType: type}
    updateData({style: newStyle})
    if (type === TempLineType.Solid) {
      unit.removeAttrByPath('path/strokeDasharray')
    } else if (type === TempLineType.Dashed) {
      const width = newStyle.width || 2;
      const dashLen = width * 2
      unit.setAttrByPath('path/strokeDasharray', `${dashLen}, ${dashLen}`)
    }
  }


  return <div className="unit-container">
    {hasHeader && <div className={classNames('unit-header', 'flex-space-btw')}>
      <div>Line Options</div>
    </div>}
    <div className="p-1">
      <div>Color</div>
      <input type="color" onChange={onColorChange} style={{width: 200}} value={style.color} className="mt-1" />
    </div>

    <div className="p-1">
      <div>Stroke Width</div>
      <Select className="mt-1" value={style.width} onChange={onWidthChange} style={{width: 200}}>
        <Select.Option value="1">Thin</Select.Option>
        <Select.Option value="2">Normal</Select.Option>
        <Select.Option value="4">Thick</Select.Option>
      </Select>
    </div>

    <div className="p-1">
      <div>Line Type</div>
      <Select className="mt-1" value={style.type} onChange={onTypeChange} style={{width: 200}}>
        <Select.Option value={TempLineType.Solid}>Solid</Select.Option>
        <Select.Option value={TempLineType.Dashed}>Dashed</Select.Option>
      </Select>
    </div>

    <div className="p-1">
      <div>Points</div>
      <div className="mt-1">
        <PointsEditor unit={unit} key={JSON.stringify(allPoints)}/>
      </div>
    </div>
    
  </div>
}